//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import { dialog } from 'src/boot/mixins.js';
export default {
  name: 'InviteUsersErrors',
  mixins: [dialog],
  components: {
    TeDialog: TeDialog
  },
  data: function data() {
    return {
      loading: false
    };
  },
  props: ['errorList', 'skip'],
  methods: {
    skipToDashboard: function skipToDashboard() {
      this.loading = true;
      this.skip();
    }
  }
};